import './CustomLegends.css';

// Function to find the color of the last theme for each SI
const findLastThemeColor = (themes) => {
  const lastTheme = themes[themes.length - 1]; // Get the last theme
  return lastTheme ? lastTheme.color : '#000'; // Return the color of the last theme (or black if no themes)
};

const CustomLegends = ({ customLegends }) => {
  console.log(customLegends);

  // This will store unique SI themes for each SI across all waves
  const siThemesMap = {};

  // Loop through customLegends to gather all themes by SI (across waves)
  Object.entries(customLegends).forEach(([wave, siData]) => {
    Object.entries(siData).forEach(([si, themes]) => {
      if (!siThemesMap[si]) {
        siThemesMap[si] = [];
      }

      // Add only unique themes for each SI
      themes.forEach(theme => {
        if (!siThemesMap[si].some(t => t.color === theme.color)) {
          siThemesMap[si].push(theme);
        }
      });
    });
  });

  return (
    <div className="custom-legends">
      {Object.entries(siThemesMap).map(([si, themes], siIdx) => {
        // Find the color of the last theme for each SI
        const lastThemeColor = findLastThemeColor(themes);

        return (
          <div key={siIdx} style={{ display: 'flex', alignItems: 'center',  }}>
            <div className='customSI-legends-container'>
              {/* Color Span on the left */}
              <span
                style={{
                  width: '10px',
                  height: '10px',
                  backgroundColor: lastThemeColor,
                  display: 'inline-block',
                  marginRight: '10px', // Space between color and SI text
                  borderRadius: '50%',
                }}
              />

              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px' }}>
                {/* SI Legend with fixed width and ellipsis */}
                <div
                  style={{
                    color: '#25282B',
                    fontSize: '14px',
                    marginRight: '10px',
                    borderRadius: '4px',
                    width: '150px', // Fixed width
                    whiteSpace: 'nowrap', // Prevent text from wrapping
                    overflow: 'hidden', // Hide overflowing text
                    textOverflow: 'ellipsis', // Add ellipsis when text overflows
                    cursor: 'pointer', // Make it appear clickable
                  }}
                  title={si} // Tooltip on hover to show full text
                >
                  {si}
                </div>
              </div>
            </div>

            {/* Themes */}
            <div
              style={{
                borderLeft: `2px solid ${lastThemeColor}`, // Set left border color to last theme color
                paddingLeft: '5px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {themes.map((theme, themeIdx) => (
                <div
                  key={themeIdx}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '10px',
                    marginBottom: '5px',
                  }}
                >
                  <div
                    style={{
                      width: '10px',
                      height: '10px',
                      backgroundColor: theme.color,
                      display: 'inline-block',
                      marginRight: '10px',
                    }}
                  />
                  <div>{theme.theme}</div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CustomLegends;
